module.exports = __webpack_public_path__ + "img/china-Post.56d73bfe.png";